import * as React from "react";
import { forwardRef } from "react";
const SvgStatusBarHigh = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 60, viewBox: "0 0 8 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ColorStatusHigh-gn" }, /* @__PURE__ */ React.createElement("path", { id: "Surface", d: "M2 2H6V58H2V2Z", fill: "#334155" })));
const ForwardRef = forwardRef(SvgStatusBarHigh);
export { ForwardRef as ReactComponent };
